import { Component, inject, OnInit } from '@angular/core';
import { NgbActiveModal } from '@shared/components/lib-ng/lib-ng-bootstrap/modal/modal-ref';
import { InputPhoneFormComponent } from '../input-form/input-phone-form.component';
import { CommonModule } from '@angular/common';
import { InputPhoneOtpComponent } from '../input-otp/input-otp.component';
import { ChangePhoneSuccessComponent } from '../change-phone-success/change-phone-success.component';

@Component({
  standalone: true,
  imports: [InputPhoneFormComponent, CommonModule, InputPhoneOtpComponent, ChangePhoneSuccessComponent],
  selector: 'app-change-phone-number',
  templateUrl: './change-phone-number.component.html',
  styleUrls: ['./change-phone-number.component.css']
})
export class ChangePhoneNumberComponent implements OnInit {
  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }

  public activeModal = inject(NgbActiveModal);

  public CURRENT_STEP = 'inputEmailStep';
  public currentEmailAddress = '';

  onSubmitEmail(event: any) {
    this.currentEmailAddress = event?.phoneNumber ?? '';
    this.CURRENT_STEP = 'inputOtpStep';
  }
}
